<template>
  <div class="tree-result-filter card">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-8">
          <div v-if="dataSelectedControlObjective && dataSelectedControlObjective.id > 0">
            <h5 class="h5">
              {{ $t('maintenance.framework_control.table.selected_control_objective_label') }}:
              <font-awesome-icon icon="book"/>
              {{ dataSelectedControlObjective.name }}
            </h5>
            <div>{{ dataSelectedControlObjective.description | truncate(260) }}</div>
          </div>
          <div v-else>
            <h5 style="margin-bottom:5px;">
              {{ $t('maintenance.framework_control.table.all_control_objectives_label') }}
            </h5>
          </div>
        </div>

        <div class="col-md-4 text-right" v-if="dataSelectedControlObjective && dataSelectedControlObjective.id > 0">
          <span @click="showViewCOModal()"
                qid="view-modal"
                class="btn btn-view"
          >
            <font-awesome-icon icon="eye"/>
          </span>
          <span v-if="isGranted([permissions.CONTROL_OBJECTIVE_EDIT, permissions.CONTROL_OBJECTIVE_EDIT_OWN], dataSelectedControlObjective.created_by) && (!getClient.parent || (getClient.parent && dataSelectedControlObjective.partition))"
                class="btn btn-edit"
                qid="edit-oc-modal"
                @click="showEditCOModal(dataSelectedControlObjective)"
          >
            <font-awesome-icon icon="pen"/>
          </span>
          <span v-if="isGranted([permissions.CONTROL_OBJECTIVE_DELETE, permissions.CONTROL_OBJECTIVE_DELETE_OWN], dataSelectedControlObjective.created_by) && (!getClient.parent || (getClient.parent && dataSelectedControlObjective.partition))"
                class="btn btn-delete"
                qid="delete-oc-modal"
                @click="showConfirmDeleteCOModal(dataSelectedControlObjective)"
          >
            <font-awesome-icon icon="trash-alt"/>
          </span>
        </div>
      </div>
    </div>


    <!-- Delete Control Objective confirm modal template -->
    <b-modal ref="delete-control-objective" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideConfirmDeleteCOModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-m-title">
            {{ $t('maintenance.control_objective.delete.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="delete-co-error"
      >
        {{ error }}
      </b-alert>

      <div class="mb-2 mt-3" style="font-size:18px;">
        <div>
          {{ $t('maintenance.control_objective.delete.description') }}
          <span class="text-bold">
            {{ itemToDelete.name }}
          </span>
        </div>
        <div class="mt-2">
          {{ $t('maintenance.control_objective.delete.are_you_sure') }}
        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="mt-3"
                            variant="secondary"
                            @click="hideConfirmDeleteCOModal"
                            qid="delete-co-cancel-button"
                  >
                    {{ $t('maintenance.control_objective.delete.cancel') }}
                  </b-button>
                  <b-button @click="confirmDeleteCO(itemToDelete)"
                            class="mt-3 ml-3"
                            variant="danger"
                            qid="delete-co-submit-button"
                            v-if="isGranted([permissions.CONTROL_OBJECTIVE_EDIT, permissions.CONTROL_OBJECTIVE_EDIT_OWN], framework.created_by) && (!getClient.parent || (getClient.parent && framework.partition))"
                            :disabled="buttonDisabled"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.control_objective.delete.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>



    <!-- Edit Control Objective modal template -->
    <b-modal ref="edit-control-objective" @hide="hideEditCOModal" modal-class="task-modal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideEditCOModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="update-tp-title">
            {{ $t('maintenance.control_objective.update.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-oc-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="editCOFormSubmit" qid="edit-oc-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-oc-name-label">
              {{ $t('maintenance.control_objective.create.name_label') }}
            </label>
            <span class="text-red">*</span>
            <b-form-input
              qid="edit-oc-form-name"
              type="text"
              v-model="coForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.control_objective.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-control-objective-description-label">
              {{ $t('maintenance.control_objective.create.description_label') }}
            </label>
            <b-form-textarea
                qid="create-control-objective-form-description"
                v-model="coForm.description"
                rows="6"
                max-rows="6"
                :placeholder="$t('maintenance.control_objective.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideEditCOModal"
                            qid="edit-oc-cancel-button"
                  >
                    {{ $t('maintenance.control_objective.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="ml-3"
                            variant="success"
                            @click="editCOFormSubmit"
                            :disabled="buttonDisabled"
                            qid="edit-oc-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('maintenance.control_objective.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- View Control Objective -->
    <b-modal ref="view-control-objective" modal-class="task-modal" @hide="hideViewCOModal">
      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideViewCOModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" qid="view-oc-title">
            {{ $t('maintenance.control_objective.title') }}
          </h5>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>

      <label class="mt-3">
        {{ $t('maintenance.control_objective.create.name_label') }}
      </label>
      <br>
      <span v-if="dataSelectedControlObjective.name" qid="view-oc-name">
        {{ dataSelectedControlObjective.name }}
      </span>
      <br>

      <label class="mt-3" v-if="dataSelectedControlObjective && dataSelectedControlObjective.description">
        {{ $t('maintenance.control_objective.create.description_label') }}
      </label>
      <br>
      <span v-if="dataSelectedControlObjective.description" qid="view-oc-name">
        {{ dataSelectedControlObjective.description }}
      </span>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class=""
                            variant="secondary"
                            @click="hideViewCOModal"
                            qid="view-oc-cancel-button"
                  >
                    {{ $t('processes.policies.view.close') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import FrameworkControlViewModal from '@/views/Frameworks/FrameworkControlViewModal.vue';

  export default {
    name: 'FrameworkTopBar',
    data: function() {
      return {
        // loading: true,
        coForm: {
          name: '',
          description: ''
        },
        error: '',
        buttonDisabled: false,
        itemToDelete: {},
        // copy of selectedControlObjective prop
        dataSelectedControlObjective: []
      }
    },
    props: {
      selectedControlObjective: [],
      selectedControlObjectiveDeleted: false,
      framework: {},
    },
    watch: {
      selectedControlObjective: function (newValue, oldValue) {
        // Watching the prop and setting it's copy object which is used in this component
        if (newValue) {
          this.dataSelectedControlObjective = newValue
        } else {
          this.dataSelectedControlObjective = []
        }
      },
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
    },
    methods: {
      // Control Objective methods
      showViewCOModal() {
        this.error = '';
        this.$refs['view-control-objective'].show()
      },
      hideViewCOModal() {
        this.$refs['view-control-objective'].hide()
      },

      // Edit CO
      showEditCOModal(object) {
        let self = this;
        this.error = '';

        this.coForm.slug = object.slug;
        this.coForm.name = object.name;
        this.coForm.description = object.description;
        this.$refs['edit-control-objective'].show()
      },

      hideEditCOModal() {
        this.error = ''
        this.openControlObjective = {};
        this.$refs['edit-control-objective'].hide()
      },

      editCOFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        this.coForm.client = this.getClient.slug;

        if (this.coForm.name && this.coForm.name.length) {
          piincHttp.put('control-objectives/' + this.coForm.slug, this.coForm).then(function(response) {
            self.hideEditCOModal();
            self.buttonDisabled = false;
            // Store new value from API for updated Control Objective
            self.dataSelectedControlObjective = response.data
            // Emit event together with new value
            self.$emit('forceSideFilterRenderComponent', self.dataSelectedControlObjective)
            self.$toastr('success', self.$t('maintenance.control_objective.update.success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.buttonDisabled = false;
          this.error = ''
          if (this.coForm.name == '') {
            this.error +=  ' ' + this.$t('maintenance.incidents.incident_categories.create.name_error')
          }
        }
      },
      // Delete CO
      showConfirmDeleteCOModal(object) {
        let self = this;
        this.buttonDisabled = true;
        this.error = '';

        piincHttp.get('control-objectives/' + object.slug).then(function(response) {
          self.itemToDelete = response.data
          self.buttonDisabled = false
        }, function() {});

        // this.itemToDelete = object
        this.$refs['delete-control-objective'].show()
      },
      hideConfirmDeleteCOModal() {
        this.itemToDelete = {}
        this.$refs['delete-control-objective'].hide()
      },
      confirmDeleteCO(object) {
        let self = this;
        this.buttonDisabled = true;

        if (object.has_framework_controls == 0) {
          piincHttp.delete('control-objectives/' + object.slug).then(function(response) {
            self.hideConfirmDeleteCOModal();
            self.$emit('forceSideFilterRenderComponent')
            self.buttonDisabled = false;
            self.$toastr('success', self.$t('maintenance.control_objective.delete.success'))
          }, function() {});
        }else{
          self.buttonDisabled = false;
          self.error = this.$t('maintenance.control_objective.delete.linked_framework_controls_error');
        }
      }
    },
    created () {
      let self = this;
      // Create a copy of prop object to avoid directly mutating a prop (throws error)
      this.dataSelectedControlObjective = this.selectedControlObjective
    }
  }
</script>
